
export function handleInputCompania() {

    const inputs = document.getElementsByName("Compañía_actual");
    const iconArrow = document.getElementsByClassName("img_arrow-down");
    const selects = document.getElementsByClassName('compania_options');

    for (let index = 0; index < inputs.length; index++) {

        const totalOptions = selects[index].options
        let options = selects[index].options;

        inputs[index].addEventListener('input', function () {
            let inputValue = this.value.toLowerCase();
            let totalMostrar = 0;

            for (let i = 0; i < options.length; i++) {
                let optionText = options[i].text.toLowerCase();
                let optionValue = options[i].value.toLowerCase();

                if (optionText.includes(inputValue) || optionValue.includes(inputValue)) {
                    options[i].style.display = '';
                } else {
                    options[i].style.display = 'none';
                    totalMostrar++;
                }
            }

            // Abrir el desplegable al filtrar opciones
            if (inputValue !== '') {
                selects[index].size = options.length - totalMostrar;
                selects[index].classList.add('compania_options_open');
            } else {
                selects[index].size = totalOptions.length;
                selects[index].classList.remove('compania_options_open');
            }

            if (totalMostrar === options.length) {
                selects[index].classList.remove('compania_options_open');
            }
        });

        selects[index].addEventListener('change', function () {
            let valorSeleccionado = this.value;
            inputs[index].value = valorSeleccionado;

            // Cerrar el desplegable al seleccionar una opción
            selects[index].size = totalOptions.length;
            selects[index].classList.remove('compania_options_open');
            gestionarNoCampaña(inputs[index].value) ?
                validarInput(inputs[index], true) :
                validarInput(inputs[index], false);

        });

        function despliegueTotal() {
            // Desplegar todas las opciones al hacer clic en el campo de búsqueda
            options = totalOptions;
            selects[index].size = totalOptions.length;

            for (let i = 0; i < options.length; i++) {
                options[i].style.display = '';
            }
            selects[index].classList.add('compania_options_open');
        }

        inputs[index].addEventListener('click', despliegueTotal);
        iconArrow[index].addEventListener('click', despliegueTotal);

        document.addEventListener('click', function (event) {
            if (!selects[index].contains(event.target) && !inputs[index].contains(event.target) && !iconArrow[index].contains(event.target)) {
                // Cerrar el desplegable si se hace clic fuera del campo de selección y del campo de búsqueda
                selects[index].size = totalOptions.length;
                selects[index].classList.remove('compania_options_open');
            }
        });
    }

}